<template>
  <div class="phone-input">
    <input
      type="tel"
      @input="inputFunc($event.target)"
      @blur="blur"
      :placeholder="placeholder"
      ref="phoneNumber"
    />
    <div class="info-prompt" v-if="wrong">
      <div class="icon"></div>
      {{ promptText }}
    </div>
  </div>
</template>

<script>
export default _extend({
  name: 'PhoneInput',
  props: {
    field: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    enterLength: {
      type: Number,
      default: 11
    },
    value: {
      type: String,
      default: ''
    },
    promptText: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wrong: false,
      phone: this.value
    };
  },
  watch: {
    wrong(val) {
      this.$emit('updateError', this.field, val);
    }
  },
  methods: {
    // 这逻辑太吓人了 想不通
    inputFunc(target) {
      const num = target.value.toString().replace(/\s*[^\d]/g, '');
      const phone = num.substring(0, 11);

      const isAdd = phone.length > this.phone.length;
      const _originSelectionStart = target.selectionStart;
      const _originLength = target.value.length;
      let step = 0;
      if (_originSelectionStart === 4 || _originSelectionStart === 9) {
        step = 1;
      }
      let phoneStr = '';
      if (phone.length < 4) {
        this.$emit('sendPhone', '');
        phoneStr = phone;
      } else if (phone.length < 8) {
        this.$emit('sendPhone', '');
        phoneStr = phone.substring(0, 3) + ' ' + phone.substring(3);
      } else if (phone.length < 12) {
        this.$emit('sendPhone', '');
        phoneStr =
          phone.substring(0, 3) +
          ' ' +
          phone.substring(3, 7) +
          ' ' +
          phone.substring(7);
      } else if (phone.length > 11) {
        this.$emit('sendPhone', '');
        phoneStr =
          phone.substring(0, 3) +
          ' ' +
          phone.substring(3, 7) +
          ' ' +
          phone.substring(7, 11);
      }
      if (phone.length === 11) {
        const result = this.isPhoneAvailable(phone);
        if (!result) {
          this.wrong = true;
          this.$emit('updateError', this.field, true);
          this.$emit('sendPhone', '');
        } else {
          this.wrong = false;
          this.$emit('updateError', this.field, false);
          this.$emit('sendPhone', phone);
        }
      }
      target.value = phoneStr;
      setTimeout(() => {
        // const len = target.value.length;
        // target.setSelectionRange(len, len);
        if (_originLength !== _originSelectionStart) {
          const _step = isAdd ? step : -step;
          target.setSelectionRange(
            _originSelectionStart + _step,
            _originSelectionStart + _step
          );
        }
      }, 20);
      this.phone = phone;
    },
    isPhoneAvailable(phone) {
      phone = phone.replace(/\s*|[^\d]/g, '');
      const myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      return myreg.test(phone);
    },
    blur() {
      // phone校验
      this.wrong = !this.isPhoneAvailable(this.phone);
      setTimeout(() => {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 300);
    }
  },
  mounted() {
    this.$refs.phoneNumber.value = this.value;
  }
});
</script>

<style lang="scss" scoped>
@import './PhoneInput.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/ActiveForm/PhoneInput/PhoneInput.vue